"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var orderRouter = {
  type: 1,
  path: '/organization',
  component: _layout.default,
  redirect: '',
  name: '',
  meta: {
    title: 'organizationManagement',
    icon: 'g-organization'
  },
  children: [{
    type: 2,
    path: 'organization-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-organization-management/organization-management'));
      });
    },
    name: 'organization:view',
    meta: {
      title: 'organizationManagement'
    },
    children: [{
      path: 'add',
      name: 'organization:add',
      hidden: true
    }, {
      path: 'update',
      name: 'organization:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'organization:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'organization:export',
      hidden: true
    }, {
      path: 'rechargeOrderAdd',
      name: 'organization:rechargeOrderAdd',
      hidden: true
    }, {
      path: 'approve',
      name: 'organization:approve',
      hidden: true
    }, {
      path: 'cancel',
      name: 'organization:cancel',
      hidden: true
    }]
  }, {
    type: 3,
    path: "organization-cost",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sms-organization-management/organization-cost"));
      });
    },
    name: "organizationCost:view",
    hidden: true,
    props: true,
    meta: {
      title: "organizationCost",
      noCache: true
    },
    children: [{
      path: 'add',
      name: 'organizationCost:add',
      hidden: true
    }, {
      path: 'update',
      name: 'organizationCost:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'organizationCost:delete',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'organization-user-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-organization-management/organization-user-management'));
      });
    },
    name: 'organizationUser:view',
    meta: {
      title: 'organizationUserManagement'
    },
    children: [{
      path: 'add',
      name: 'organizationUser:add',
      hidden: true
    }, {
      path: 'update',
      name: 'organizationUser:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'organizationUser:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'organizationUser:export',
      hidden: true
    }, {
      path: 'unlock',
      name: 'organizationUser:unlock',
      hidden: true
    }, {
      path: 'lock',
      name: 'organizationUser:lock',
      hidden: true
    }, {
      path: 'resetPassword',
      name: 'organizationUser:resetPassword',
      hidden: true
    }, {
      path: 'limitUpdate',
      name: 'organizationUser:limitUpdate',
      hidden: true
    }, {
      path: 'forceLogoff',
      name: 'organizationUser:forceLogoff',
      hidden: true
    }, {
      path: 'google:key',
      name: 'organizationUser:google:key',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'organization-user-permission',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-organization-management/organization-user-permission'));
      });
    },
    name: 'organizationUserMenu:view',
    meta: {
      title: 'organizationUserPermission'
    },
    children: [{
      path: 'add',
      name: 'organizationUserMenu:add',
      hidden: true
    }, {
      path: 'delete',
      name: 'organizationUserMenu:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'organizationUserMenu:export',
      hidden: true
    }, {
      path: 'update',
      name: 'organizationUserMenu:update',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'organization-user-settings',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-organization-management/organization-user-settings'));
      });
    },
    name: 'organizationUserSystemConfig:view',
    meta: {
      title: 'organizationUserSettings'
    },
    children: [{
      path: 'add',
      name: 'organizationUserSystemConfig:add',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'organization-operation-log',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-organization-management/organization-operation-log'));
      });
    },
    name: 'organizationLog:view',
    meta: {
      title: 'organizationOperationLog'
    },
    children: []
  }]
};
var _default = orderRouter;
exports.default = _default;